// src/api/widgetAPI.js
//
// Helper untuk memanggil endpoint widget tunggal:
//   GET /api/v1/dashboard/overview?widget=<name>&filter[key]=value
//
// Contoh:
//   widgetAPI.fetch('top10_username', { period: '24h', limit: 10 })
//   widgetAPI.fetch('radius_user_by_status', { radius_server_id: 1 })
//   widgetAPI.fetch('online_count', { realm: 'myrealm' })

import api from './index';

const widgetAPI = {
  /**
   * Fetch satu widget dari backend.
   * @param {string} widget  - nama widget (lihat daftar di dashboard_api.rb)
   * @param {object} filter  - optional filter: { period, radius_server_id, tenant_id, realm, limit, from, to }
   */
  fetch(widget, filter = {}) {
    const params = { widget };
    Object.entries(filter).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') {
        params[`filter[${k}]`] = v;
      }
    });
    return api.get('/dashboard/overview', { params });
  },
};

export default widgetAPI;